export const loadScript = (url: string, onLoad: any, onError?: () => void) => {
  const script = document.createElement('script')
  script.src = url
  script.async = true
  script.onload = onLoad
  if (onError) script.onerror = onError

  document.body.appendChild(script)
  return () => {
    document.body.removeChild(script)
  }
}
